<section class="work-order-history" aria-label="Work-order history" [attr.aria-busy]="loading">
  <header class="history-header">
    <div>
      <h2>Work-order history</h2>
      <p>Changes to this work order and its related records.</p>
    </div>
    <button type="button" (click)="refresh()" [disabled]="loading">Refresh</button>
  </header>

  <nav class="history-filters" aria-label="History categories">
    <button
      type="button"
      (click)="selectCategory('all')"
      [attr.aria-pressed]="category === 'all'"
      [disabled]="loading"
    >
      All changes
    </button>
    <button
      type="button"
      (click)="selectCategory('details')"
      [attr.aria-pressed]="category === 'details'"
      [disabled]="loading"
    >
      Work-order details
    </button>
    <button
      type="button"
      *ngIf="showFinancials"
      (click)="selectCategory('financial')"
      [attr.aria-pressed]="category === 'financial'"
      [disabled]="loading"
    >
      Financials
    </button>
  </nav>

  <p class="history-error" role="alert" *ngIf="error">{{ error }}</p>
  <p class="history-status" role="status" *ngIf="loading">Loading work-order history…</p>
  <p class="history-empty" *ngIf="!loading && !error && groups.length === 0">
    No recorded changes match this view.
  </p>

  <details class="history-group" *ngFor="let group of groups; trackBy: trackGroup">
    <summary class="group-header">
      <div>
        <div>
          <strong>{{ group.actor }}</strong>
          <span class="actor-badge" *ngIf="group.verified">AMS user</span>
        </div>
        <div class="summary-event-badge" *ngFor="let mainEvent of summaryEvents(group.events)">
          <span [class.deleted]="mainEvent.operation === 'DELETE'">{{ action(mainEvent) }}</span>
          <span>
            {{ mainEvent.entity }}<span *ngIf="mainEvent.description"> · {{ mainEvent.description }}</span>
          </span>
        </div>
      </div>
      <time [attr.datetime]="group.changedAt">{{ group.changedAt | date:'medium' }}</time>
    </summary>

    <details class="history-event" *ngFor="let event of group.events; trackBy: trackEvent">
      <summary>
        <span class="event-action" [class.deleted]="event.operation === 'DELETE'">
          {{ action(event) }}
        </span>
        <span class="category-badge" *ngIf="event.category === 'financial'">Financial</span>
        <span>
          {{ event.entity }}<span *ngIf="event.description"> · {{ event.description }}</span>
        </span>
      </summary>

      <div class="change-scroll" *ngIf="event.changes.length; else noFieldDetails">
        <table>
          <caption class="visually-hidden">{{ event.entity }} changes</caption>
          <thead>
            <tr>
              <th scope="col">Field</th>
              <th scope="col">Before</th>
              <th scope="col">After</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let change of event.changes">
              <th scope="row">{{ change.label }}</th>
              <td>{{ value(change.before, change) }}</td>
              <td>{{ value(change.after, change) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noFieldDetails>
        <p class="history-status">Record {{ action(event) | lowercase }}.</p>
      </ng-template>
    </details>
  </details>

  <div class="history-footer">
    <p>{{ coverage }}</p>
    <button type="button" *ngIf="nextCursor" (click)="older()" [disabled]="loading">
      Load older changes
    </button>
  </div>
</section>
